import { render } from "./EntityRecordView.vue?vue&type=template&id=9a9a6f30&scoped=true"
import script from "./EntityRecordView.vue?vue&type=script&lang=js"
export * from "./EntityRecordView.vue?vue&type=script&lang=js"

import "./EntityRecordView.vue?vue&type=style&index=0&id=9a9a6f30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a9a6f30"]])

export default __exports__